const withTypingTimer = (Component) => ({ timer = 2_000, onChange, ...props }) => {
    let inputValue = {};
    let typingTyper = undefined;

    const handleKeyUp = () => {
        clearTimeout(typingTyper);
        typingTyper = setTimeout(dispatch, timer);
    }

    const dispatch = () => {
        if (onChange) {
            onChange(inputValue);
        }
    }

    const handleChange = (event) => {
        inputValue = event;
    };

    return (
        <Component {...props} onChange={handleChange} onKeyUp={handleKeyUp} />
    );
}

export { withTypingTimer };
